import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})

export class ToastService {
  constructor(private messageService: MessageService) { }

  showSuccess(message: string) {
    this.messageService.add({ key: 'br', severity: 'success', summary: 'Success', detail: message, life: 1500 });
  }

  showError(message: string) {
    this.messageService.add({ key: 'br', severity: 'error', summary: 'Error', detail: message, life: 1500 });
  }

  showInfo(message: string) {
    this.messageService.add({ key: 'br', severity: 'info', summary: 'Info', detail: message });
  }

  showWarn(message: string) {
    this.messageService.add({ key: 'br', severity: 'warn', summary: 'Warning', detail: message });
  }

  // Shows the per-action coin billing block the backend now returns on
  // the 16 recruitment endpoints (JD refine, approvals, CV ranking,
  // hiring report, offer letters, etc). `consumption` is the response's
  // own `coin_consumption` object — { feature, free_tier, coins_deducted,
  // remaining_coins, ... } — so this needs no extra lookup.
  showCoinConsumption(consumption: any) {
    if (!consumption) {
      return;
    }

    const featureLabel = this.formatFeatureName(consumption.feature);
    const remaining = this.formatCoins(consumption.remaining_coins);

    const detail = consumption.free_tier
      ? `${featureLabel} — free this time · ${remaining} coins left`
      : `${featureLabel} — ${this.formatCoins(consumption.coins_deducted)} coins used · ${remaining} left`;

    this.messageService.add({
      key: 'br',
      severity: consumption.free_tier ? 'info' : 'success',
      summary: consumption.free_tier ? '🎁 Free Action' : '💰 Coins Used',
      detail,
      life: 3000,
    });
  }

  private formatFeatureName(feature: string): string {
    if (!feature) {
      return 'Action';
    }
    return feature
      .toLowerCase()
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  private formatCoins(value: number): string {
    return (value ?? 0).toLocaleString();
  }

}